import { articles } from '@/mocks/articles';
import ArticleLayout from '@/pages/article/components/ArticleLayout';

export default function ArticleSicurezza() {
  const article = articles.find((a) => a.slug === 'itaobuy-spreadsheet-sicurezza')!;
  return <ArticleLayout article={article} />;
}